module.exports = __webpack_public_path__ + "static/img/technology10.b44bb0ed.png";